<template>
  <div id="dashboard">
    <div v-if="dashboardData" v-bind:class="{ spinner: isLoading }">
      <CxDashboardHeader  v-if="true" 
                          :dashboardData="dashboardData"
                          :focusKpis="focusKpis"
                          :outletInfo="getOutletInfo"
                          :scoreInfo="getOverallScore"
                          :showRetailers="false"
                          :theme="theme"
                          :threshold="colorRange || FallbackColorRange"
                          />

      <!-- Content (w. Lead Management (DE)) -->
      <b-tabs v-if="cxTabs.length !== 0 || (hasLeadManagement && (isBrandUsed('Land Rover') || isBrandUsed('Jaguar')))" 
              class="app-ctrl app-ctrl-tabs"
              v-model="activeCxTab"
              @changed="activeCxTab = 0">
        <b-tab  v-if="hasLeadManagement && isBrandUsed('Land Rover')" 
                :title="getTitle('Land Rover')" 
                class="app-ctrl">
          <branded-card-collection  brand="Land Rover"
                                    :clientInfo="getClientInfo"
                                    :clientLocationId="dashboardData.ClientLocationId"
                                    :marginKpiGroups="LRMarginKPIGroups"
                                    :showLeadingMarginEvaluation="true"
                                    :theme="theme"
                                    :thresholds="colorRange" />
        </b-tab>

        <b-tab  v-if="hasLeadManagement && isBrandUsed('Jaguar')" 
                :title="getTitle('Jaguar')" 
                class="app-ctrl">
          <branded-card-collection  brand="Jaguar" 
                                    :clientInfo="getClientInfo"
                                    :clientLocationId="dashboardData.ClientLocationId" 
                                    :marginKpiGroups="JMarginKPIGroups"
                                    :showLeadingMarginEvaluation="true"
                                    :theme="theme"
                                    :thresholds="colorRange" />
        </b-tab>

        <!-- Loyalty bonus-->
        <b-tab v-if="loyaltyBonusYears != null && loyaltyBonusYears.length > 0" :title="$t('Webportal.CX.LoyaltyBonus')" 
                class="app-ctrl">
          <LoyaltyBonusCard :clientLocationId="dashboardData.ClientLocationId" 
                            :colorRange="colorRange || FallbackColorRange"
                            :loyaltyBonusYears="loyaltyBonusYears"/>
        </b-tab>
      </b-tabs>

      <MarginHelpPopups   :colorRange="colorRange || FallbackColorRange"/>
    </div>
  </div>
</template>

<script>
import EventBus from "@/services/EventBus.js";
import BuildDataUri from "@/mixins/BuildDataUri";
import DashboardService from "@/services/DashboardService";
import CancelToken from "@/mixins/CancelToken";

import Scores from "./Scores";
import ActionManagementCard from "./ActionManagementCard";
import DefaultMarginGroups from "./marginkpigroup.json";
import MarginHelpPopups from "./MarginHelpPopups.vue";

import FocusKpiBar from './FocusKpiBar.vue';

import BrandedCardCollection from '@/components/CX/DashboardCards/BrandedCardCollection';

import CxDashboardHeader from './Dashboard/CxDashboardHeader.vue';
import LoyaltyBonusCard from "./DashboardCards/LoyaltyBonusCard.vue";

export default {
  name: "Dashboard",

  components: {
    Scores,
    ActionManagementCard,
    MarginHelpPopups,
    FocusKpiBar,
    BrandedCardCollection,
    CxDashboardHeader,
    LoyaltyBonusCard
},

  mixins: [ BuildDataUri, CancelToken ],

  props: {
    defaultLogo:        String,
    colorRange:         Array,
    dashboardData:    { type: Object, default: () => {} },
    retailerSelected:   Number,
    theme:            { type: String, default: () => 'light' }
  },

  data() {
    return {
      KPIGroups: [],
      JMarginKPIGroups: JSON.parse(JSON.stringify(DefaultMarginGroups)),
      LRMarginKPIGroups: JSON.parse(JSON.stringify(DefaultMarginGroups)),
      PictureUri: "",
      scores: [],
      selectedScoreId: null,
      isMounted: false,
      // ColorRange: [],
      showBadges: false,
      FallbackColorRange: [
        {
          Minimum: 0,
          Maximum: 69.99,
          Color: "#f54052",
          Smiley: 'frown-open'
        },
        {
          Minimum: 70,
          Maximum: 89.99,
          Color: "#FFD700",
          Smiley: 'meh'
        },
        {
          Minimum: 90,
          Maximum: 100,
          Color: "#36c259",
          Smiley: 'grin'
        }
      ],
      rebuild: {
        dealer: null,
        exploration: null,
        apisFromSurveys: null
      },
      optionsCancelToken: null,
      focusKpis: {
        kpis: {},
        firstaid_solved: 0,
        firstaid_all: 0,
        isLoading: true,
        showHelpPopup: false
      },
      cancelToken1: null,

      cxTabs: [],
      activeCxTab: 0,

      cancelToken: undefined,
      explorationData: [],
      afsData: undefined,
      nonAfsData: undefined,
      isLoadingExplorations: false,
      isLoadingAFS: false,
      isLoadingNonAFS: false,

      loyaltyBonusYears: null
    };
  },

  computed: {
    getOutletInfo() {
      return {
        image: this.PictureUri || this.defaultLogo,
        name: this.dashboardData.Name,
        address: this.dashboardData.Address,
        zipCode: this.dashboardData.PostalCode,
        city: this.dashboardData.City,
        outletId: this.rebuild?.dealer?.ClientLocationIdOnClientSite,
        cxScore: this.dashboardData.CXScore,
        country: this.dashboardData.CountryId,
        data: this.rebuild
      };
    },

    getOverallScore() {
      return {
        showTreeSelect: true,
        showSelector: false,
        scores: this.scores,
        scoreData: this.rebuild?.dealer?.Scores,
        threshold: this.colorRange || this.FallbackColorRange
      };
    },

    getClientInfo() {
      if (!this.rebuild || !this.rebuild.dealer || !this.dashboardData)
        return;

      let { Name, Address, Address2, City, PostalCode, ClientLocationId } = this.dashboardData;
      return { 
        name: Name, 
        address: Address, 
        address2: Address2, 
        city: City, 
        zip: PostalCode, 
        clientLocationId: ClientLocationId,
        retailerId: this.rebuild?.dealer?.ClientLocationIdOnClientSite
      };
    },

    clientLocationId() {
      return this.dashboardData.clientLocationId;
    },

    Dealerdata: function() {
      return {
        AllTexts: this.rebuild.dealer?.AllTexts,
        CustomProperties: this.rebuild.dealer?.CustomProperties
      }
    },

    hasLeadManagement() {
      // if (!this.hasExpectedKpiGroups()) return false;
      if (this.dashboardData.CountryId === 'DE') return true;
      return false
    },

    isLoading() {
      return this.isLoadingExplorations || this.isLoadingAFS || this.isLoadingNonAFS || this.isLoadingExplorations;
    }
  },

  created() {
    this.initializeDashboardData();
  },

  mounted() {
    this.getScores();
    this.loadFocusKpi();
    this.loadCategories();
    this.getLoyaltyBonusYears();

    this.isMounted = true;

    EventBus.$on("Score_Changed", (selectedScoreId) => {
      this.selectedScoreId = selectedScoreId;
      this.getDealer_CxRebuild();
    })
  },

  watch: {
    // dashboardData.ClientLocationId
    'dashboardData.ClientLocationId'() {
      if (!this.dashboardData?.clientLocationId || !this.selectedScoreId){
      }
      else
        this.loadFocusKpi() 
    },
    
    selectedScoreId() { 
      if (!this.dashboardData?.clientLocationId || !this.selectedScoreId) {
      }
      else 
        this.loadFocusKpi() 
    }
  },

  methods: {
    initializeDashboardData() {
      // Check if the data is arrived. Needed because immediate is true.
      if (!this.dashboardData.ClientLocationId)
        return;

      this.PictureUri = this.buildDataUriFromGoogle(
        this?.dashboardData?.Pictures
      );

      if (!_.isUndefined(this.dashboardData?.KPI?.KPIGroup)) {
        this.KPIGroups = this.dashboardData.KPI.KPIGroup;
        var JMarginKPIGroupsCopy = _.cloneDeep(this.JMarginKPIGroups);
        this.JMarginKPIGroupsTmp = [];

        var LRMarginKPIGroupsCopy = _.cloneDeep(this.LRMarginKPIGroups);
        this.LRMarginKPIGroupsTmp = [];

        this.KPIGroups.forEach(group => {
          group.ActionsToTake = 0;
          group.Items = _.filter(
            this.dashboardData.KPI.KPI,
            k => k.GroupCode == group.Code
          );

          group.Items.forEach(kpi => {
            kpi.ShowPopup = false;
            kpi.PopupPosition = {};

            if (!kpi.IsAccomplished) group.ActionsToTake++;
          });

          // collect 'Margin-Kpi-Groups'
          if(group.Code == 'Jaguar - 0.5% Margin' || group.Code == 'Jaguar - 1% Margin') {
            this.JMarginKPIGroupsTmp.push(group);
          } 
          if(group.Code == 'Land Rover - 0.5% Margin' || group.Code == 'Land Rover - 1% Margin') {
            this.LRMarginKPIGroupsTmp.push(group);
          }
        });

        // Merge margin kpi groups
        this.JMarginKPIGroupsTmp.forEach(newGroup => {
          JMarginKPIGroupsCopy.forEach((group, index, arr) => {
            if(newGroup.Code.includes(group.Code)) {
              // merge items
              newGroup.Items.forEach(item => {
                arr[index].Items.forEach((oldItem,index, arr) => {
                  if (item.Code == oldItem.Code) {
                    arr[index] = _.merge(arr[index], item);
                  }
                })                  
              })
              arr[index].Code = newGroup.Code;
              arr[index].Name = newGroup.Name;
              arr[index].Result = newGroup.Result;
              arr[index].SurveyWave = newGroup.SurveyWave;
              arr[index].ActionsToTake = newGroup.ActionsToTake;
              arr[index].KpiGroupNameLong = newGroup.KpiGroupNameLong;
              arr[index].KpiGroupNameShort = newGroup.KpiGroupNameShort;
            }
          })
        })

        this.LRMarginKPIGroupsTmp.forEach(newGroup => {
          LRMarginKPIGroupsCopy.forEach((group, index, arr) => {
            if(newGroup.Code.includes(group.Code)) {
              // merge items
              newGroup.Items.forEach(item => {
                arr[index].Items.forEach((oldItem,index, arr) => {
                  if (item.Code == oldItem.Code) {
                    arr[index] = _.merge(arr[index], item);
                  }
                })                  
              })
              arr[index].Code = newGroup.Code;
              arr[index].Name = newGroup.Name;
              arr[index].Result = newGroup.Result;
              arr[index].SurveyWave = newGroup.SurveyWave;
              arr[index].ActionsToTake = newGroup.ActionsToTake;
              arr[index].KpiGroupNameLong = newGroup.KpiGroupNameLong;
              arr[index].KpiGroupNameShort = newGroup.KpiGroupNameShort;
            }
          })
        })

        this.JMarginKPIGroups = JMarginKPIGroupsCopy;
        this.LRMarginKPIGroups = LRMarginKPIGroupsCopy;
      }

      // Allow access on Ratings entries by using their name
      _.forEach(this.dashboardData.Exploration, ex => {
        if (typeof ex == "object" && ex.Ratings)
          ex.RatingsByName = _.keyBy(ex.Ratings, "Name");
      });

      // Allow google popup access to full address for map search
      if (this.dashboardData?.Exploration?.Google) {
        this.dashboardData.Exploration.Google.FullAddress = this.dashboardData.Brand ? this.dashboardData.Brand + ', ' : '';
        this.dashboardData.Exploration.Google.FullAddress += this.dashboardData.AllTexts;
      }

      // Set resolved lists, if not present
      this.dashboardData.Exploration.ResolvedApis = this.dashboardData.Exploration.ResolvedApis || [];

      if (this.dashboardData && this.dashboardData.ExplorationAugmention) {
        this.dashboardData.ExplorationAugmention.ResolvedApisFromSurveys = this.dashboardData?.ExplorationAugmention?.ResolvedApisFromSurveys || [];
      }

      // temporary, till dealer-request is swapped
      this.getDealer_CxRebuild();
    },

    initializeExplorationData() {

      for (let i = 0; i < this.dashboardData.cxDashboardTabs.length; i++) {
        const item = this.dashboardData.cxDashboardTabs[i];
        if (!item.apiId) {
          // TODO: das sollte vielleicht als if-elseif-elseif gemacht werden 

          // Exploration
          let afs = this.afsData.Categories?.find(x => x.TranslationString == item.category);
          if (afs) {
            for (const afsItem of afs.AFSItems) {
              if (afsItem.ExternalSurveyId === item.ExternalSurveyId) {
                item.hasExploration = true;
              }
            }
          }
          // NonExploration
          let nonAfs = this.nonAfsData.Categories?.find(x => x.TranslationString == item.category);
          if (nonAfs) {
            for (const nonAfsItem of nonAfs.AFSItems) {
              if (nonAfsItem.ExternalSurveyId === item.ExternalSurveyId) {
                item.hasNonExploration = true;
              }
            }
          } 
        } 
        // API
        if (item.apiId) {
          let exploration = this.explorationData?.find(x => x.ApiID == item.apiId);
          if (exploration && exploration.isActive && exploration.OverallScores && exploration.OverallScores.length > 0) {
            item.hasApi = true;
          } else {
            item.hasApi = false;
          }
        }
      }

    },

    getCxTabs() {
      let structure = [];
      if (!this.dashboardData.cxDashboardTabs)
        return structure;
      
      // get unique labels = "Dashboard Tab Names"
      let labels = _.uniq(this.dashboardData.cxDashboardTabs.map(x => x.label));
      for (const i in labels) {
        
        let hasAnyApi = this.dashboardData.cxDashboardTabs.filter(x => x.label === labels[i]).some(x => x.hasApi);
        let hasExploration = this.dashboardData.cxDashboardTabs.filter(x => x.label === labels[i]).some(x => x.hasExploration);
        let hasNonExploration = this.dashboardData.cxDashboardTabs.filter(x => x.label === labels[i]).some(x => x.hasNonExploration);
        
        if (!hasAnyApi && !hasExploration && !hasNonExploration)
          continue;

        let tabItem = { label: labels[i], categories: [] };
        if (hasAnyApi) {
          let categoryNames = _.uniq(this.dashboardData.cxDashboardTabs.filter(x => x.label == labels[i]).map(x => x.category));
          for (const j in categoryNames) {
            let category = { name: categoryNames[j], apis: [] };
            let apis = this.dashboardData.cxDashboardTabs.filter(x => x.label == labels[i] && x.category == categoryNames[j]);
            for (const k in apis) {
              category.apis.push(apis[k]);
            }
            if (category.apis.length > 0)
              tabItem.categories.push(category);
          }
        } 
        
        if (hasExploration) {
          let categoryNames = _.uniq(this.dashboardData.cxDashboardTabs.filter(x => x.label == labels[i]).map(x => x.category));
          
          for (const j in categoryNames) {
            let category = { name: categoryNames[j], apis: [] };
            let afs = this.afsData.Categories?.find(x => x.TranslationString == categoryNames[j]);
            
            if (afs) {
              for (const k in afs.AFSItems) {
                afs.AFSItems[k].type = 'EXPLORATION';
                category.apis.push(afs.AFSItems[k]);
              }
            }
            if (category.apis.length > 0)
              tabItem.categories.push(category);
          }
        }

        if (hasNonExploration) {
          let categoryNames = _.uniq(this.dashboardData.cxDashboardTabs.filter(x => x.label == labels[i]).map(x => x.category));

          for (const j in categoryNames) {
            let category = { name: categoryNames[j], apis: [] };
            let nonAfs = this.nonAfsData.Categories?.find(x => x.TranslationString == categoryNames[j]);
            if (nonAfs) {
              for (const k in nonAfs.AFSItems) {
                nonAfs.AFSItems[k].type = 'NONEXPLORATION';
                category.apis.push(nonAfs.AFSItems[k]);
              }
            }
            if (category.apis.length > 0)
              tabItem.categories.push(category);
          }
        }
        
        if (tabItem.categories.length > 0)
          structure.push(tabItem);
      }
      return structure;
    },

    loadCategories() {
      let clientLocId = this.dashboardData.ClientLocationId;
      let scoreId = this.scoreId || -1;
      if(scoreId == undefined || clientLocId == undefined) return;

      this.isLoadingExplorations = true;
      this.isLoadingAFS = true;
      this.isLoadingNonAFS = true;

      let promise1 = DashboardService.GetDealerApisFromSurveys(clientLocId, this.cancelToken, scoreId, false)
        .then(res => {
          this.afsData = res.data;
        }).finally(() => {
          this.isLoadingAFS = false;
        });

      let promise2 = DashboardService.GetDealerApisFromSurveys(clientLocId, this.cancelToken, scoreId, true)
        .then(res => {
          this.nonAfsData = res.data;
        }).finally(() => {
          this.isLoadingNonAFS = false;
        });
           
      let promise3 = DashboardService.GetDealerExploration(clientLocId, this.cancelToken, scoreId)
        .then(res => {
          this.explorationData = res.data;
        }).finally(() => {
          this.isLoadingExplorations = false;
        });

      Promise.all([promise1, promise2, promise3]).then((values) => {
        this.initializeExplorationData();
        this.cxTabs = this.getCxTabs();
      }).catch((error) => {
        console.log(error);
      });

    },

    // API ... lots
    async loadFocusKpi() {
      this.focusKpis.isLoading = true;

      // Get Foxus KPI
      this.cancelToken1 = this.initCancelToken(this.cancelToken1);
      let result = await DashboardService.getDealerFocuskpis(
        this.dashboardData.ClientLocationId, 
        this.cancelToken1, 
        this.scoreId || -1);
      this.focusKpis.kpis = result.data;
      
      // Get the average response time
      this.cancelToken1 = this.initCancelToken(this.cancelToken1);
      result = await DashboardService.GetDealerKpis(
        this.dashboardData.ClientLocationId, this.cancelToken1, -1, "Enquiry Responsiveness", "");
      if (result.data[0].Kpis == null) {
        this.$delete(this.focusKpis.kpis, 'avg_responsetime');
      } else {
        var results = result.data[0].Kpis.map(kpi => kpi.SurveyInstances?.[0].QuestionResult)
        var sum = results.reduce((a,b) => a + b, null);
        var avg = sum/results.filter(r => r != null).length;
        this.focusKpis.kpis.avg_responsetime.value = avg;
      }

      // Get NC/UC - Visualpresentation
      this.cancelToken1 = this.initCancelToken(this.cancelToken1);
      result = await DashboardService.GetDealerKpis(
        this.dashboardData.ClientLocationId, this.cancelToken1, -1, "CX Top Bar KPI", "");
      
      if (result.data[0].Kpis == null) {
        this.$delete(this.focusKpis.kpis, 'ncuc_visualpresentation');
      } else {
        this.focusKpis.kpis.ncuc_visualpresentation.value = result.data[0].Kpis[0]?.AggregatedResultOfLastSurveyInstancesPerSurvey;
      }  

      this.focusKpis.kpis.firstaidkits.value = this.focusKpis.firstaid_solved;
      this.focusKpis.kpis.firstaidkits.threshold = this.focusKpis.firstaid_all; 
    
      this.focusKpis.isLoading = false; 
    },

    isBrandUsed(brand) {
      return brand && this.dashboardData.CxBrand && this.dashboardData.CxBrand.includes(brand);
    },

    hasExpectedKpiGroups() {
      return !(this.dashboardData.ExpectedKpiGroups == null);
    },

    // CALL DashboardService.getDealerRebuild
    getDealer_CxRebuild() {
      this.optionsCancelToken = this.initCancelToken(this.optionsCancelToken);

      DashboardService.getDealerRebuild(
        this.retailerSelected,
        this.optionsCancelToken,
        this.selectedScoreId || -1
      )
      .then(response => {
        this.rebuild.dealer = null;
        if (response.data) {
          this.rebuild.dealer = response.data;
        } 
      })
      .catch((error) => {
        console.error(`CALL: getDealer_CxRebuild DONE`, error)
      })
      .finally(() => {
        //this.isLoadingDealer = false;
      });
    },

    // CALL DashboardService.GetDealerExploration
    getDealerExploration() {
      this.optionsCancelToken = this.initCancelToken(this.optionsCancelToken);

      return DashboardService.GetDealerExploration(
        this.retailerSelected,
        this.optionsCancelToken,
        -1
      )
      .then(response => {
        this.rebuild.exploration = null;
        if (response.data) {
          this.rebuild.exploration = response.data;
        } 
      })
      .finally(() => {
        //this.isLoadingDealer = false;
      });
    },

    getDealerApisFromSurveys() {
      this.optionsCancelToken = this.initCancelToken(this.optionsCancelToken);

      return DashboardService.GetDealerApisFromSurveys(
        this.retailerSelected,
        this.optionsCancelToken,
        -1,
        false
      )
      .then(response => {
        this.rebuild.apisFromSurveys = null;
        if (response.data) {
          this.rebuild.apisFromSurveys = response.data;
        } 
      })
      .finally(() => {
        //this.isLoadingDealer = false;
      });
    },

    getColor(value) {
      if (!this.colorRange) {
        return this.FallbackColorRange.find(
          thres => thres.Minimum <= value && thres.Maximum >= value
        )?.Color;
      }

      return this.colorRange.find(
        thres => thres.Minimum <= value && thres.Maximum >= value
      )?.Color;
    },

    async getScores() {
      if (!this.dashboardData.ClientId || !this.dashboardData.CountryId) 
        return;

      let result = await DashboardService.getScores(
        this.dashboardData.ClientId, this.dashboardData.CountryId);
      this.scores = result.data.map(score => (
        {
          label: score.ScoreName,
          id: score.ScoreId
        }));
      this.selectedScoreId = result.data.selectedScoreId || -1;
    },

    getDealer() {
      if (this.isMounted) {
        EventBus.$emit("Score_Changed", this.selectedScoreId);
        this.getScoreThresholds(this.dashboardData.ClientId, this.selectedScoreId);
      } else {
      };
    },

    // API
    getScoreThresholds(clientId, scoreId) {
      DashboardService.getThresholds(clientId, scoreId)
      .then(response => {
        this.colorRange = response.data;
      });
    },

    getTitle(brand) {
      return `${this.$t('Webportal.CX.Margin')} ${brand}`;
    },

    getLoyaltyBonusYears() {
      DashboardService.GetLoyaltyBonusYears(this.dashboardData.ClientLocationId)
      .then(response => {
        this.loyaltyBonusYears = response.data;
      });
    }
  }
};
</script>

<!-- Scoped Component Style -->
<style scoped>
.card-group .col {
  min-width: 300px;
}

.cx-grid-kpi {
  display: grid;
   height: 100%;
  grid-template-columns: 3fr 2fr 2fr 2fr 2fr 2fr 3fr;
  grid-gap: 0.5rem;
  justify-content: stretch;
}
.pigrid {
  display: grid;
   height: 100%;
  grid-template-columns: 1fr 1fr 1fr;
  /* grid-template-rows: auto; */
  grid-gap: 0.5rem;
  /* margin: 0.5rem; */
  justify-content: stretch;
}
.dbgrid{
  max-height: 20rem
}
.tooltip-override ::v-deep .tooltip-inner {
  max-width: 500px !important;
}
.scoreSelect {
  display: flex;
  align-items: center;
}
#ExplainCxScore {
  margin-inline: 5%;
}

#dashboard ::v-deep .popup {
  box-shadow: 3px 3px 13px -3px var(--border-color-secondary);
  height: auto;
  max-height: 80vh;
  border: 1px solid var(--border-color-secondary);
  border-radius: var(--border-radius-popup);
}

#dashboard ::v-deep .msm-title {
  font-size: 1.5rem;
  font-weight: bold;
  margin-bottom: 1.2rem;
  padding: 0.25rem;
}

#dashboard ::v-deep .lines-2 {
  min-height: 4.5rem;
}

#dashboard ::v-deep .lines-3 {
  min-height: 9rem;
}

#dashboard ::v-deep .help-icon {
  position: absolute;
  right: 0%;
  top: 0%;
  margin: 1rem;
}

#dashboard ::v-deep table.table tbody + tbody {
  border-top: none !important;
}

#dashboard ::v-deep table.table th:first-child {
  padding-left: 0.4rem;
}

#dashboard ::v-deep table.table td {
  padding: 0.4rem;
}
#dashboard ::v-deep th  {
  font-weight: normal;
}
#dashboard ::v-deep tr {
  font-size: 0.9rem;
  position: relative;
}
#dashboard ::v-deep .stripe {
  background-color: rgba(0, 0, 0, 0.05);
}
#dashboard ::v-deep .highlighted {
  box-shadow: inset 0 0px 6px #01DF74;
}

#dashboard ::v-deep .weight_badge {
  position: absolute;
  font-size: 1rem !important;
  right: -7px;
  top: -7px;
}

.google-image {
  aspect-ratio: 4/3;
  object-fit: cover;
  overflow: hidden;
}
</style>